/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type aggregatesListingMap_listing$ref: FragmentReference;
declare export opaque type aggregatesListingMap_listing$fragmentType: aggregatesListingMap_listing$ref;
export type aggregatesListingMap_listing = {|
  +slug: string,
  +mapData: ?{|
    +point: ?{|
      +lat: number,
      +lng: number,
    |},
    +area: ?{|
      +coordinates: $ReadOnlyArray<$ReadOnlyArray<$ReadOnlyArray<[number, number]>>>
    |},
  |},
  +$refType: aggregatesListingMap_listing$ref,
|};
export type aggregatesListingMap_listing$data = aggregatesListingMap_listing;
export type aggregatesListingMap_listing$key = {
  +$data?: aggregatesListingMap_listing$data,
  +$fragmentRefs: aggregatesListingMap_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "aggregatesListingMap_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListingMapData",
      "kind": "LinkedField",
      "name": "mapData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Coordinates",
          "kind": "LinkedField",
          "name": "point",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lat",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lng",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "lowRes",
              "value": true
            }
          ],
          "concreteType": "GeoJSONMultiPolygon",
          "kind": "LinkedField",
          "name": "area",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "coordinates",
              "storageKey": null
            }
          ],
          "storageKey": "area(lowRes:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '31a6ee3381ab596fc617f296eb521b84';

export default node;
